(function () {
    'use strict';

    angular
            .module('caloappApp')
            .config(caloriesConfig);

    caloriesConfig.$inject = ['$stateProvider'];

    function caloriesConfig($stateProvider) {
        $stateProvider
                .state('user-calories', {
                    parent: 'app',
                    url: '/user-calories/:username?page',
                    data: {
                        authorities: ['ROLE_USER', 'ROLE_ADMIN'],
                        pageTitle: 'calories.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/calories/calories.html',
                            controller: 'CaloriesController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        fromDate: {
                            value: null,
                            squash: true
                        },
                        toDate: {
                            value: null,
                            squash: true
                        },
                        fromTime: {
                            value: null,
                            squash: true
                        },
                        toTime: {
                            value: null,
                            squash: true
                        }
                    },
                    resolve: {
                        pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {

                                var lSortParam = "date,desc";
                                return {
                                    page: PaginationUtil.parsePage($stateParams.page),
                                    sort: lSortParam,
                                    predicate: PaginationUtil.parsePredicate(lSortParam),
                                    ascending: PaginationUtil.parseAscending(lSortParam),
                                    fromDate: PaginationUtil.parsePage($stateParams.fromDate),
                                    toDate: PaginationUtil.parsePage($stateParams.toDate),
                                    fromTime: PaginationUtil.parsePage($stateParams.fromTime),
                                    toTime: PaginationUtil.parsePage($stateParams.toTime)
                                };
                            }],
                        mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('calories');
                                return $translate.refresh();
                            }]
                    }
                })
                .state('user-calories.delete', {
                    parent: 'user-calories',
                    url: '/{idMealInfo}/delete',
                    data: {
                        authorities: ['ROLE_USER', 'ROLE_ADMIN'],
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                            $uibModal.open({
                                templateUrl: 'app/calories/delete/user-calories-delete-dialog.html',
                                controller: 'UserCaloriesDeleteController',
                                controllerAs: 'vm',
                                size: 'md'
                            }).result.then(function () {
                                $state.go('user-calories', null, {reload: true});
                            }, function () {
                                $state.go('^');
                            });
                        }]
                });
    }
})();
